exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Styles for coloring the different notie popups */\n\n.notie-background-error {\n\tbackground-color: #dc1632;\n}\n\n.notie-background-success {\n\tbackground-color: #4caf50;\n}\n\n.notie-textbox-inner pre {\n\tbackground-color: inherit;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/MICSS/client/src/assets/css/notie.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;CACC,0BAA0B;CAC1B;;AAED;CACC,0BAA0B;CAC1B;;AAED;CACC,0BAA0B;CAC1B","file":"notie.css","sourcesContent":["/* Styles for coloring the different notie popups */\n\n.notie-background-error {\n\tbackground-color: #dc1632;\n}\n\n.notie-background-success {\n\tbackground-color: #4caf50;\n}\n\n.notie-textbox-inner pre {\n\tbackground-color: inherit;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??ref--7-2!./src/assets/css/notie.css
// module id = dVyn
// module chunks = 3